"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSAK_TARGET_COUNTRIES = exports.MERCURYO_TARGET_COUNTRIES = exports.BANXA_TARGET_COUNTRIES = exports.RAMP_TARGET_COUNTRIES = exports.CEX_TARGET_COUNTRIES = exports.SIMPLEX_TARGET_COUNTRIES = exports.MOONPAY_TARGET_COUNTRIES = void 0;
// 50% users from these regions directed to these providers
exports.MOONPAY_TARGET_COUNTRIES = [
    "AO",
    "AR",
    "AU",
    "BT",
    "BR",
    "BN",
    "CM",
    "CA",
    "CO",
    "CG",
    "DM",
    "EE",
    "ET",
    "FJ",
    "FR",
    "GM",
    "DE",
    "GD",
    "GY",
    "HK",
    "HU",
    "JO",
    "KE",
    "KG",
    "LA",
    "LB",
    "LI",
    "MW",
    "MX",
    "MZ",
    "NO",
    "PY",
    "PT",
    "RO",
    "KN",
    "ST",
    "SA",
    "ES",
    "SR",
    "SE",
    "CH",
    "TJ",
    "TN",
    "TR",
    "UZ",
    "VN",
];
exports.SIMPLEX_TARGET_COUNTRIES = [
    "AO",
    "BH",
    "BZ",
    "BM",
    "BW",
    "BR",
    "BF",
    "CG",
    "DO",
    "EG",
    "EE",
    "GR",
    "HU",
    "IL",
    "LT",
    "MH",
    "MN",
    "NL",
    "SA",
    "RS",
    "SG",
    "ZA",
    "GS",
    "TW",
];
exports.CEX_TARGET_COUNTRIES = [];
exports.RAMP_TARGET_COUNTRIES = ["IS"];
exports.BANXA_TARGET_COUNTRIES = [
    "AU",
    "AZ",
    "BT",
    "BN",
    "CV",
    "CA",
    "CY",
    "EG",
    "FJ",
    "GA",
    "GL",
    "KG",
    "MO",
    "MY",
    "NA",
    "NZ",
    "NG",
    "PG",
    "QA",
    "RE",
    "SH",
    "VC",
    "MF",
    "SN",
    "SC",
    "SG",
    "SB",
    "TW",
    "TO",
    "TM",
    "AE",
    "VN",
    "ZM",
];
exports.MERCURYO_TARGET_COUNTRIES = [
    "AD",
    "AR",
    "AZ",
    "BH",
    "BE",
    "BZ",
    "BM",
    "BA",
    "BW",
    "BG",
    "BF",
    "CV",
    "CM",
    "HR",
    "CY",
    "CZ",
    "DM",
    "DO",
    "ET",
    "FO",
    "FI",
    "GA",
    "GM",
    "GI",
    "GL",
    "GD",
    "GY",
    "GG",
    "HK",
    "IE",
    "IL",
    "IT",
    "IM",
    "JE",
    "JO",
    "KE",
    "LA",
    "MO",
    "MW",
    "MY",
    "MT",
    "MH",
    "MX",
    "MC",
    "MN",
    "ME",
    "MZ",
    "NA",
    "NL",
    "NZ",
    "NG",
    "PY",
    "PL",
    "PT",
    "QA",
    "RE",
    "RO",
    "SH",
    "KN",
    "VC",
    "MF",
    "ST",
    "SN",
    "RS",
    "SC",
    "SK",
    "SI",
    "SB",
    "ZA",
    "GS",
    "ES",
    "SR",
    "TJ",
    "TO",
    "TR",
    "TM",
    "UA",
    "AE",
    "UZ",
    "ZM",
];
exports.TRANSAK_TARGET_COUNTRIES = [
    "AD",
    "BE",
    "HR",
    "CZ",
    "FI",
    "FR",
    "DE",
    "GR",
    "IS",
    "IT",
    "LT",
    "MD",
    "MC",
    "NO",
    "PL",
    "SK",
    "SI",
    "SE",
    "CH",
    "UA",
];
//# sourceMappingURL=targetCountries.js.map